<template>
  <v-sheet max-width="350" :color="wsLIGHTCARD" class="pa-3 wsRoundedLight">


    <h5 class="wsDARKLIGHT ">
     {{ $time(item.createdAt).regularTime()  }}
    </h5>

    <!-- TEXT -->
    <h5 v-if="item.short_content && !expand" class="wsDARKER font-weight-regular">
      {{ item.short_content }}
      <span @click="expand=true" class="wsATTENTION pointer">... {{ $t('More') }}</span>
    </h5>


    <!-- TEXT -->
    <v-expand-transition>
      <h5 v-if="expand || !item.short_content"
          class="wsDARKER font-weight-regular"
          v-html="parsedContent">
      </h5>
    </v-expand-transition>





    <!-- POSTER -->
    <ws-img
        v-if="item.poster && item.poster.type === 'image'"
        :src="item.poster.url"
        class="wsRoundedLight mt-5"

    />



  </v-sheet>
</template>


<script>

export default {
  name: "mobileNewsCard",
  props : {
    item : {
      type : Object,
      default() { return {} }
    }
  },
  data() {
    return {
      md: null,
      expand : false
    }
  },
  async created() {
    const MarkdownIt = (await import("markdown-it")).default;
    this.md = new MarkdownIt();
  },
  computed: {
    parsedContent() {
      return this.md ? this.md.render(this.item.content || "") : "";
      // return this.item.content.replace(/\n/g, "<br>");
    },
  },
  methods : {
    prepareText(text){

      return text.replace(/\n/g, "<br>");
    }
  }
}
</script>


<style scoped>

</style>